define('casino/activity-feed',['jquery', 'casino/casino', 'all/navigation', 'all/interval-manager', 'casino/game-mode', 'casino/info', 'casino/ingameFunctionalities', 'casino/instantdeposit', '../all/lib/fakeLocalStorage'],
	function ($, casino, navigation, IntervalManager, gameMode, casinoInfo, ingameFunctionalities, instantDeposit) {
		'use strict';

		var resizeTimeout;
		var RESIZE_DELAY = 100;
		var centerColumnWidth;
		var normalFeedWidth;
		var thinFeedWidth;
		var feedInterval;
		var isFeedIntervalSetMin = false;

		sessionStorage.setItem('resizedGame', false);

		function addClick($selector, clickCallback) {
			addEvent($selector, 'click', clickCallback);
		}

		function addEvent($selector, event, clickCallback) {
			$selector.off(event, clickCallback);
			$selector.on(event, clickCallback);
		}

		function contractActivityFeed(event) {
			event.preventDefault();
			stopAndHideFeedInner();
			$('#activity-feed').attr('class', 'cnt-activity-feed');
			var $instantDepositInGame = $('#instant-deposit-ingame');
			if (ingameFunctionalities.isGameLoaded() || ingameFunctionalities.isGroupLoaded()) {

				if (sessionStorage.getItem('resizedGame') === 'true') {
					ingameFunctionalities.resizeGameFrameToShowOrNotFeedAndDeposit(ingameFunctionalities.DO_NOT_ALLOW_SHOWING_OF_DEPOSIT_AND_FEED_WHEN_RESOLUTION_LOW);
					sessionStorage.setItem('resizedGame', false);
				} else {
					isFeedIntervalSetMin = false;
					return;
				}
				if ($instantDepositInGame.hasClass('expanded')) {
					$instantDepositInGame.removeClass('expanded');
					$instantDepositInGame.removeClass('compact');
				}
			}
		}

		function initiateExpandingTheActivityFeed() {
			$('#activity-feed-inner').fadeIn('fast');

			startFeed();
			$('#activity-feed').attr('class', 'cnt-activity-feed expanded ');
		}

		//for both games and groups
		function handleIngameExpandFeedSizing() {
			var $instantDepositInGame = $('#instant-deposit-ingame');

			if (ingameFunctionalities.isAllowedToAddMaximumFeedAndDeposit()) {
				initiateExpandingTheActivityFeed();
			} else if (ingameFunctionalities.isAllowedToAddCompactFeedAndDeposit()) {
				transformFeedFromIconToCompactSize();
				if (!$instantDepositInGame.hasClass('compact')) {
					$instantDepositInGame.addClass('compact');
					$instantDepositInGame.addClass('expanded');
				}
			} else {
				//if there no space to put any size of feed or deposit than resize the game frame and put compact feed and deposit
				if (!$instantDepositInGame.hasClass('compact')) {
					$instantDepositInGame.addClass('compact');
					$instantDepositInGame.addClass('expanded');
				}
				//save the default size of the game in sessionStorage so that we can access it again
				//whenever the player wants to see the default size of the game + minimized version of deposit and feed
				sessionStorage.setItem('defaultSizeOfResizedGame', ingameFunctionalities.calculateGameFrameSize());
				ingameFunctionalities.resizeGameFrameToShowOrNotFeedAndDeposit(ingameFunctionalities.ALLOW_SHOWING_OF_DEPOSIT_AND_FEED_WHEN_RESOLUTION_LOW);
				sessionStorage.setItem('resizedGame', true);
				transformFeedFromIconToCompactSize();
			}
		}

		function expandActivityFeed(event) {
			event.preventDefault();
			//make sure we are on the ingame module
			if (location.hash.indexOf('game=') > 0 || location.hash.indexOf('group=') > 0) {
				if (ingameFunctionalities.isGameLoaded()) {
					handleIngameExpandFeedSizing();
				} else if (ingameFunctionalities.isGroupLoaded()) {
					handleIngameExpandFeedSizing();
				} else {
					initiateExpandingTheActivityFeed();
					resizeFeedAndDepositBasedOnGameRatioAndScreenResolution();

				}
			}//when we are on lobby
			else {
				initiateExpandingTheActivityFeed();
				handleSizeChange();
			}
		}

		function setUpdateFeedInterval() {
			setTimeout(function changeUpdateIntervalOfFeed() {
				if (isFeedIntervalSetMin === true && (ingameFunctionalities.isFeedMaximumSize() || ingameFunctionalities.isFeedMediumSize())) {

					if ($('#activity-feed-inner').css('display') !== 'none') {
						IntervalManager.clearInterval(feedInterval);
						isFeedIntervalSetMin = false;
						feedInterval = IntervalManager.setInterval(updateFeed, 60 * IntervalManager.SECONDS);
					}
				}
			}, 500);
		}

		addClick($('#contract_activity_feed'), contractActivityFeed);
		addClick($('#expand_activity_feed'), expandActivityFeed);

		function createWinnerInfo(winner) {
			var game = casino.getGame(winner.gameId);
			var url;
			var icon = '', name = '';

			if (game) {
				icon = game.icon;
				name = game.name;
			}

			if (icon === '') {
				url = navigation.staticURL('img/tmp-game-icon.png');
			} else {
				url = navigation.dynamicURL(icon);
			}

			return {
				icon: url,
				player: '<span class="ui-flag ' + winner.country + '_small"></span> <strong>' + winner.player + '</strong>',
				game: '<a href="#!game=' + winner.gameId + '">' + name + '</a>',
				amount: winner.amount
			};
		}

		function updateSlides(winners) {
			var $activityFeed = $('#activity-feed');
			var $slideTemplate = $activityFeed.find('.slideshow').find('template');
			var winnerInfo = [];
			for (var i = 0; i < winners.length; i++) {
				winnerInfo.push(createWinnerInfo(winners[i]));
			}
			$activityFeed.scrollerReplaceSlides(function () {
				$slideTemplate.applyTemplate(winnerInfo, {into: $(this)});
				$(this).find('article').click(function () {
					window.location.hash = $(this).find('a').attr('href');
				});
			});
			$activityFeed.scroller({direction: 'down'});
		}

		function showMaximumSizeFeed(winners) {
			var $activityFeed = $('#activity-feed');
			$activityFeed.addClass('expanded');
			$activityFeed.removeClass('compact');//this class is present when coming from main page with compact feed to ingame
			$activityFeed.fadeIn('fast', function () {
				$('#activity-feed-inner').show();
				updateSlides(winners);
			});
		}

		function showCompactSizeFeed(winners) {
			var $activityFeed = $('#activity-feed');
			$activityFeed.addClass('expanded');
			$activityFeed.addClass('compact');
			$activityFeed.fadeIn('fast', function () {
				$('#activity-feed-inner').show();
				updateSlides(winners);
			});
		}

		function showFeed(winners) {

			if (location.hash.indexOf('game=') > 0 || location.hash.indexOf('group=') > 0) {

				if (ingameFunctionalities.isAllowedToAddMaximumFeedAndDeposit()) {
					instantDeposit.changeInstantDepositToMaximizedWidth();
					showMaximumSizeFeed(winners);
					isFeedIntervalSetMin = true;
					setUpdateFeedInterval();
				} else if (ingameFunctionalities.isAllowedToAddCompactFeedAndDeposit()) {
					instantDeposit.changeInstantDepositToCompactWidth();
					showCompactSizeFeed(winners);
					isFeedIntervalSetMin = true;
					setUpdateFeedInterval();
				} else {
					var $activityFeed = $('#activity-feed');
					$activityFeed.css('display', 'block');
					$activityFeed.removeClass('expanded');
					$activityFeed.removeClass('compact');
					$('#activity-feed-inner').hide();
					instantDeposit.changeInstantDepositToMinimizedWidth();
				}
			}
			else {
				if (casinoInfo.isScreenWidthGreaterOrEqualThanMediumLevel()) {
					showMaximumSizeFeed(winners);
					setUpdateFeedInterval();
				} else if (casinoInfo.isScreenWidthBetweenBottomLevelAndMediumLevel()) {
					showCompactSizeFeed(winners);
					setUpdateFeedInterval();
				} else if (casinoInfo.isScreenWidthEqualOrLessThanBottomLevel()) {
					hideFeed();
				}
			}
		}

		function hideFeed() {
			$('#activity-feed').fadeOut('fast', function () {
				$('#activity-feed').scrollerStop();
			});
		}

		function updateFeed() {
			var request = $.ajax({
				type: 'GET',
				url: '/pp?flow=GetCasinoWinners'
			});
			request.done(function (winners) {
				if (winners.length > 0 && gameMode.getGameMode() === gameMode.MODE_ONE_GAME) {
					showFeed(winners);
				} else if (winners.length > 0 && $('#casino-ingame').css('display') === 'none') {
					showFeed(winners);
				} else if (winners.length > 0 && (gameMode.getGameMode() === gameMode.MODE_FOUR_GAMES || gameMode.getGameMode() === gameMode.MODE_TWO_GAMES)) {
					hideFeed();
				} else if (winners.length === 0) {
					instantDeposit.resizeDepositWhenWinnersFeedEmpty();
				}
			});
			request.fail(function (jqXHR, textStatus) {
				console.log('Request failed: ' + textStatus);
				hideFeed();
			});
		}

		function startFeed() {
			if (feedInterval === undefined && !isFeedIntervalSetMin) {
				updateFeed();
				isFeedIntervalSetMin = true;
			}
		}

		function stopAndHideFeed() {
			IntervalManager.clearInterval(feedInterval);
			feedInterval = undefined;
			var $activityFeed = $('#activity-feed');
			$activityFeed.scrollerStop();
			$activityFeed.fadeOut('fast');
			$activityFeed.css('display', 'none');
		}

		function stopAndHideFeedInner() {
			IntervalManager.clearInterval(feedInterval);
			feedInterval = undefined;
			$('#activity-feed').scrollerStop();
			var $feedInner = $('#activity-feed-inner');
			$feedInner.fadeOut('fast');
			$feedInner.css('display', 'none');
		}

		function transformFeedFromMediumSizeToMaximumSize() {
			$('#activity-feed').removeClass('compact');
			updateFeed();
		}

		function transformFeedFromMaximumSizeToMediumSize() {
			$('#activity-feed').addClass('compact');
			updateFeed();
		}

		function transformFeedFromIconToCompactSize() {
			if (ingameFunctionalities.isFeedMediumSize()) {
				return;
			}
			transformFeedFromHiddenToMediumSize();
		}

		function transformFeedFromIconToMaximizedSize() {
			$('#expand_activity_feed').trigger('click');
		}

		function transformFeedFromHiddenToMaximumSize() {
			startFeed();
		}

		function transformFeedFromHiddenToMediumSize() {
			if (ingameFunctionalities.isFeedMediumSize()) {
				return;
			}
			var $activityFeed = $('#activity-feed');
			$activityFeed.css('display', 'block');
			if (!$activityFeed.hasClass('compact')) {
				$activityFeed.addClass('compact');
				$activityFeed.addClass('expanded');
			}
			if (isFeedIntervalSetMin && ingameFunctionalities.isFeedIcon()) {
				updateFeed();
			}
			startFeed();
		}

		function changeWinnersFeedToMaximizedWidth() {
			if (ingameFunctionalities.isFeedHidden()) {
				isFeedIntervalSetMin = false;
				transformFeedFromHiddenToMaximumSize();
			} else if (ingameFunctionalities.isFeedMediumSize()) {
				transformFeedFromMediumSizeToMaximumSize();
			} else if (ingameFunctionalities.isFeedMaximumSize()) {
				updateFeed();
			} else if (ingameFunctionalities.isFeedIcon()) {
				isFeedIntervalSetMin = false;
				transformFeedFromIconToMaximizedSize();
			}
		}

		function changeWinnersFeedToCompactWidth() {
			if (ingameFunctionalities.isFeedHidden()) {
				isFeedIntervalSetMin = false;
				transformFeedFromHiddenToMediumSize();
			} else if (ingameFunctionalities.isFeedMediumSize()) {
				updateFeed();
			} else if (ingameFunctionalities.isFeedMaximumSize()) {
				transformFeedFromMaximumSizeToMediumSize();
			} else if (ingameFunctionalities.isFeedIcon()) {
				isFeedIntervalSetMin = false;
				transformFeedFromIconToCompactSize();
			}
		}

		function changeWinnersFeedToMinimizedWidth() {
			stopAndHideFeed();
			stopAndHideFeedInner();
			isFeedIntervalSetMin = false;
		}

		function changeWinnersFeedToIcon() {
			$('#contract_activity_feed').trigger('click');
		}

		function handleSizeChange() {
			if (location.hash.indexOf('game=') > 0 || location.hash.indexOf('group=') > 0) {
				return;
			}
			if (casinoInfo.isScreenWidthGreaterOrEqualThanMediumLevel()) {
				changeWinnersFeedToMaximizedWidth();
			} else if (casinoInfo.isScreenWidthBetweenBottomLevelAndMediumLevel()) {
				changeWinnersFeedToCompactWidth();
			} else if (casinoInfo.isScreenWidthEqualOrLessThanBottomLevel()) {
				changeWinnersFeedToMinimizedWidth();
			}
		}

		function moveToLobby() {
			var $feed = $('#activity-feed');
			var $casino = $('#casino-ingame');
			if (ingameFunctionalities.isFeedIcon()) {
				$feed.css('display', 'none');
			}
			$casino.after($feed);
			if (!isFeedIntervalSetMin) {
				isFeedIntervalSetMin = true;
			}
			updateFeed();
		}

		function moveToIngame() {
			var $feed = $('#activity-feed');
			if ($feed.css('display') !== 'none') {
				if (ingameFunctionalities.isAllowedToAddMaximumFeedAndDeposit()) {
					changeWinnersFeedToMaximizedWidth();
					instantDeposit.changeInstantDepositToMaximizedWidth();
				} else if (ingameFunctionalities.isAllowedToAddCompactFeedAndDeposit()) {
					changeWinnersFeedToCompactWidth();
					instantDeposit.changeInstantDepositToCompactWidth();
				} else {
					changeWinnersFeedToIcon();
					instantDeposit.changeInstantDepositToMinimizedWidth();
				}
				return;
			}
			var $deposit = $('#instant-deposit-ingame');
			$deposit.after($feed);

			updateFeed();
		}


		setupResizeOnBrowserResize();
		function setupResizeOnBrowserResize() {
			$(window).on('resize', function resizeOnBrowserResize() {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(function () {
					handleSizeChange();
				}, RESIZE_DELAY);
			});
		}

		function init() {
			centerColumnWidth = $('#casino-lobby').find('.inner:first').outerWidth() || 960;
			var $feed = $('#activity-feed');
			normalFeedWidth = $feed.innerWidth();
			thinFeedWidth = normalFeedWidth - 60;
			$feed.hide();
		}

		function resizeFeedAndDepositBasedOnGameRatioAndScreenResolution() {
			if (gameMode.getGameMode() === gameMode.MODE_ONE_GAME && (ingameFunctionalities.isGameLoaded() || ingameFunctionalities.isGroupLoaded())) {
				if (ingameFunctionalities.isAllowedToAddMaximumFeedAndDeposit()) {
					changeWinnersFeedToMaximizedWidth();
					instantDeposit.changeInstantDepositToMaximizedWidth();
				} else if (ingameFunctionalities.isAllowedToAddCompactFeedAndDeposit()) {
					changeWinnersFeedToCompactWidth();
					instantDeposit.changeInstantDepositToCompactWidth();
				} else {
					changeWinnersFeedToIcon();
					instantDeposit.changeInstantDepositToMinimizedWidth();
				}
			} else if (gameMode.getGameMode() !== gameMode.MODE_ONE_GAME && (ingameFunctionalities.isGameLoaded() || ingameFunctionalities.isGroupLoaded())) {
				instantDeposit.setInstantDepositModeInvisible();
			}
		}

		var activity = {
			moveToLobby: moveToLobby,
			moveToIngame: moveToIngame,
			init: init,
			handleSizeChange: handleSizeChange,
			changeWinnersFeedToMaximizedWidth: changeWinnersFeedToMaximizedWidth,
			changeWinnersFeedToCompactWidth: changeWinnersFeedToCompactWidth,
			changeWinnersFeedToMinimizedWidth: changeWinnersFeedToMinimizedWidth,
			changeWinnersFeedToIcon: changeWinnersFeedToIcon,
			resizeFeedAndDepositBasedOnGameRatioAndScreenResolution: resizeFeedAndDepositBasedOnGameRatioAndScreenResolution
		};

		return activity;
	}
)
;

